import { render } from "./BaseInfoPage.vue?vue&type=template&id=b3460684&scoped=true"
const script = {}

import "./BaseInfoPage.vue?vue&type=style&index=0&id=b3460684&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3460684"]])

export default __exports__